// // // The Vue build version to load with the `import` command
// // // (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// // import Vue from 'vue'
// // import App from './App'
// // import router from './router'
// // import 'lib-flexible'
// import Vant from 'vant';
// import 'vant/lib/index.css';
import AMap from 'vue-amap';
// import './assets/css/base.scss';


Vue.use(AMap);
// // Vue.use(Vant);
AMap.initAMapApiLoader({
	// 高德key
	key: '6a85abcef2c3f0b395e5c8f9d4470c5c',
	// 插件集合 （插件按需引入）
	plugin: ['AMap.CitySearch']
});

// Vue.config.productionTip = false

// // /* eslint-disable no-new */
// // new Vue({
// //   el: '#app',
// //   router,
// //   components: { App },
// //   template: '<App/>'
// // })

// // The Vue build version to load with the `import` command
// // (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import Vue from 'vue'
// import App from './App'
// import store from './store/store'
// import router from './router'

// new Vue({
// 	el: '#app',
//     router,
//     store,
// 	render: h => h(App)
// 	// components: { App },
//   	// template: '<App/>'
// })








// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// import history from 'connect-history-api-fallback'
import App from './App'
import router from './router'

// import 'assets/iconfont/iconfont.css'
import store from './store/store'
import 'lib-flexible'
import Vant from 'vant';
import 'vant/lib/index.css';
// import AMap from 'vue-amap';
import './assets/css/base.scss';
import { Notify } from 'vant';
function appInit() {
	var bridge = window.KKJSBridge
	var plugins = bridge.KKIvars.plugins
}
// Vue.use(AMap);
Vue.use(Vant);
Vue.use(Notify);

// AMap.initAMapApiLoader({
// 	// 高德key
// 	key: '6a85abcef2c3f0b395e5c8f9d4470c5c',
// 	// 插件集合 （插件按需引入）
// 	plugin: ['AMap.CitySearch']
//   });

Vue.config.productionTip = false
router.afterEach((to, form, next) => {
	window.scrollTo(0,0)
})
new Vue({
	el: '#app',
    router,
    store,
	render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js